import { TThunkAction } from '../../types/redux/thunk';
import { addFavoriteRequest } from '../../services/favorite';
import { addNewbuildingFavoriteSuccess } from './addNewbuildingFavoriteActions';
import { deleteNewbuildingFavoriteSuccess } from './deleteNewbuildingFavoriteActions';
interface IAddNewbuildingFavorite {
  newbuildingId: number;
  label: string;
}

export const addNewbuildingFavorite =
  ({ newbuildingId }: IAddNewbuildingFavorite): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, httpApi }) => {
    try {
      dispatch(addNewbuildingFavoriteSuccess({ newbuildingId }));

      const response = await addFavoriteRequest({
        httpApi,
        parameters: {
          entityId: newbuildingId,
          entityType: 'newbuilding',
        },
      });

      const { isAdded } = response;

      if (!isAdded) {
        dispatch(deleteNewbuildingFavoriteSuccess({ newbuildingId }));
      }
    } catch (error) {
      logger.error(error, {
        newbuildingId,
        domain: 'src/shared/actions/newbuildingFavorite#addNewbuildingFavorite()',
        message: error.message,
      });

      dispatch(deleteNewbuildingFavoriteSuccess({ newbuildingId }));
    }
  };
